<template>
  <div
    class="filter-field-control"
    :class="{ 'filter-field-control--compact': compact }"
  >
    <b-form-group
      v-if="field.field !== 'actions' && field.type !== 'date'"
      :label="field.label"
      :label-for="inputId"
      :class="{ 'mb-0': compact }"
    >
      <div
        v-if="field.type === 'multi-select'"
        class="filter-field-control__multi-select"
      >
        <multiselect
          :id="inputId"
          :value="selectedOptions"
          :options="field.options || []"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :limit="2"
          :limit-text="(count) => `+${count}`"
          :max-height="260"
          label="descricao"
          track-by="id"
          placeholder="Buscar formas..."
          select-label=""
          deselect-label=""
          selected-label=""
          @input="
            $emit(
              'input',
              $event.map((option) => option.id)
            )
          "
        />
        <button
          v-if="selectedOptions.length"
          type="button"
          class="filter-field-control__clear"
          :aria-label="`Limpar ${field.label}`"
          @click="$emit('input', [])"
        >
          Limpar
        </button>
      </div>
      <b-input-group v-else-if="field.type !== 'select'">
        <b-form-select
          v-if="field.filterOperators"
          class="filter-field-control__operator"
          :value="operatorValue"
          :options="field.filterOperators"
          :aria-label="`Tipo de comparação para ${field.label}`"
          @input="$emit('operator-input', $event)"
        />
        <b-form-input
          :id="inputId"
          :name="field.label"
          :value="value"
          :type="field.type"
          @keydown.enter="$emit('enter')"
          @input="$emit('input', $event)"
        />
      </b-input-group>

      <b-form-select
        v-else
        :id="inputId"
        :value="value"
        :key="renderKey"
        :options="field.options"
        @input="$emit('input', $event)"
      />
    </b-form-group>

    <DatePickerInput
      v-else-if="field.type === 'date'"
      :label="field.label"
      :value="dateValues"
      :field="field.field"
      mode="range"
      @valueUpdated="$emit('date-input', $event)"
    />
  </div>
</template>

<script>
import DatePickerInput from "@/components/DatePickerInput/index.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "FilterFieldControl",
  components: {
    DatePickerInput,
    Multiselect,
  },
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
    dateValues: {
      type: Object,
      default: () => ({}),
    },
    field: {
      type: Object,
      required: true,
    },
    operatorValue: {
      default: null,
    },
    renderKey: {
      type: Number,
      default: 0,
    },
    value: {
      default: null,
    },
  },
  computed: {
    inputId() {
      return `filter-${this.field.field}`;
    },
    selectedOptions() {
      if (this.field.type !== "multi-select" || !Array.isArray(this.value)) {
        return [];
      }
      return this.value
        .map((id) =>
          (this.field.options || []).find(
            (option) => String(option.id) === String(id)
          )
        )
        .filter(Boolean);
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.filter-field-control__multi-select {
  min-width: 0;
  max-width: 100%;
}

.filter-field-control__clear {
  border: 0;
  background: transparent;
  color: #555b70;
  font-size: 12px;
  padding: 2px 0;
}

.filter-field-control__multi-select ::v-deep .multiselect__tags {
  max-width: 100%;
  overflow: hidden;
}

.filter-field-control__multi-select ::v-deep .multiselect__tag {
  background: rgba(246, 78, 96, 0.08);
  border: 1px solid rgba(246, 78, 96, 0.18);
  color: #4b5068;
}

.filter-field-control__multi-select ::v-deep .multiselect__tag-icon:after {
  color: var(--primary-color);
}

.filter-field-control__multi-select ::v-deep .multiselect__tag-icon:hover,
.filter-field-control__multi-select ::v-deep .multiselect__tag-icon:focus,
.filter-field-control__multi-select ::v-deep .multiselect__option--highlight,
.filter-field-control__multi-select
  ::v-deep
  .multiselect__option--highlight:after,
.filter-field-control__multi-select
  ::v-deep
  .multiselect__option--selected.multiselect__option--highlight,
.filter-field-control__multi-select
  ::v-deep
  .multiselect__option--selected.multiselect__option--highlight:after {
  background: var(--primary-color);
}

.filter-field-control__multi-select ::v-deep .multiselect__tag-icon:hover:after,
.filter-field-control__multi-select
  ::v-deep
  .multiselect__tag-icon:focus:after {
  color: #ffffff;
}

.filter-field-control__operator {
  flex: 0 0 145px !important;
  max-width: 145px;
}

.filter-field-control--compact ::v-deep label {
  color: #4b5068;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
}

.filter-field-control--compact ::v-deep .form-control,
.filter-field-control--compact ::v-deep .custom-select {
  height: 38px;
}

@media (max-width: 575px) {
  .filter-field-control__operator {
    flex-basis: 120px !important;
    max-width: 120px;
  }
}
</style>
